module.exports = __webpack_public_path__ + "img/defaultVoucherIco.6bc0473a.png";